import React, { useMemo } from "react";
import { Combobox, Label } from "@/components/ui";
import { ContentPageTheme, Form } from "@/services/bedrock";

interface OptionType {
  label: string;
  value: string;
}

interface Props {
  themes: ContentPageTheme[];
  forms: Form[];
  contentPageThemeId?: number | null;
  formId?: number | null;
  onChange: (updates: { contentPageThemeId?: number | null; formId?: number | null }) => void;
}

const PlayerDefaultCombobox: React.FC<{
  label: string;
  items: OptionType[];
  value?: number | null;
  emptyText: string;
  onChange: (value: number | null) => void;
}> = ({ label, items, value, emptyText, onChange }) => (
  <div className="flex flex-col gap-2">
    <Label>{label}</Label>
    <Combobox
      items={items}
      value={value ? items.find(item => item.value === String(value)) || null : null}
      onValueChange={(val: OptionType | null) => onChange(val ? Number(val.value) : null)}
      searchable
      showClear
      placeholder="Use Player default"
      emptyText={emptyText}
      isItemEqualToValue={(current, selected) => current?.value === selected?.value}
      itemToStringLabel={item => item?.label || ""}
    />
  </div>
);

const ThemeAndFormPickers: React.FC<Props> = ({ themes, forms, contentPageThemeId, formId, onChange }) => {
  const themeItems = useMemo(() => themes.map(theme => ({ label: theme.name, value: String(theme.id) })), [themes]);
  const formItems = useMemo(() => forms.map(form => ({ label: form.displayName, value: String(form.id) })), [forms]);

  return (
    <div className="grid gap-4 @min-[35rem]:grid-cols-2">
      <PlayerDefaultCombobox
        label="Theme"
        items={themeItems}
        value={contentPageThemeId}
        emptyText="No themes found"
        onChange={value => onChange({ contentPageThemeId: value })}
      />
      <PlayerDefaultCombobox
        label="Review form"
        items={formItems}
        value={formId}
        emptyText="No forms found"
        onChange={value => onChange({ formId: value })}
      />
    </div>
  );
};

export { ThemeAndFormPickers };
